import { Link } from "react-router-dom";
import { Microphone, X } from "@phosphor-icons/react";

/**
 * NudgeBanner — gentle in-app reminder if the user hasn't journaled today.
 */
export default function NudgeBanner({ visible, onDismiss }) {
  if (!visible) return null;
  return (
    <div
      className="card p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 bg-brand/5 border-brand/30"
      data-testid="nudge-banner"
    >
      <div className="w-10 h-10 rounded-full bg-brand text-bone-100 flex items-center justify-center shrink-0">
        <Microphone size={20} weight="fill" />
      </div>
      <div className="flex-1">
        <p className="font-serif text-lg text-ink-900 leading-snug">
          You haven't journaled today.
        </p>
        <p className="text-sm text-ink-500 mt-0.5">
          Even 30 seconds keeps the streak alive — your future self will thank you.
        </p>
      </div>
      <div className="flex items-center gap-2 self-end sm:self-auto">
        <button
          onClick={onDismiss}
          className="text-xs text-ink-500 hover:text-ink-900 px-2 py-1"
          data-testid="nudge-dismiss-btn"
        >
          Not now
        </button>
        <Link to="#record" className="btn-primary text-sm py-2 px-4" data-testid="nudge-record-btn">
          Record an entry
        </Link>
        <button onClick={onDismiss} className="p-1 text-ink-500 hover:text-ink-900 sm:hidden" aria-label="Dismiss">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
